// claude-allow-convention-check - this package is the single home for date/time formatters.
import { padTwo } from '../helpers/padTwo';
// formatTime(new Date('2025-12-17T14:30:00')) -> "14:30"
// formatTime(new Date('2025-12-17T09:05:00')) -> "09:05"
export const formatTime = (date) => `${padTwo(date.getHours())}:${padTwo(date.getMinutes())}`;
